import { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import { Modal } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PropTypes from 'prop-types';

import CustomIcon from '../../../common/CustomIcons';
import { updateLocalStorage } from '../../../common/utilities';

function LoginModal({ content }) {
  const [showModal, setShowModal] = useState(!updateLocalStorage.getItem('login-modal'));

  const handleCloseModal = () => {
    updateLocalStorage.setItem('login-modal', true);
    setShowModal(false);
  };

  return (
    <>
      {showModal && (
        <Modal handleCloseModal={handleCloseModal}>
          <div className="login-modal-container">
            <div
              data-testid="login-modal-btn"
              onClick={handleCloseModal}
              onKeyUp={handleCloseModal}
              role="presentation"
            >
              <CustomIcon type="close" className="close-modal" size="28" />
            </div>
            <div className="deactivate-inner-wrapper">
              <div className="login-rte-content">{ReactHtmlParser(content)}</div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}

LoginModal.propTypes = {
  content: PropTypes.string.isRequired
};
export default LoginModal;
